<div class="bix_loader">
    <div class="load_img">
        <p>{{"Please Wait" | translate}}</p>
        <img src="assets/images/loding-img.svg" alt="">
    </div>
</div>
